import './LinkFeedbackModal.css';

import { Button, Grid, TextField, Typography } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import AppLoader from 'components/Loader';
import Modal from 'components/ModalWrapper';
import { TrackFeedback } from 'utilities/insights';
import { resetSendingLinkFeedback } from 'redux/actions/feedback';
import { sendLinkFeedback } from 'redux/thunks/feedback';
import swal from 'sweetalert2';

const LinkFeedbackModal = ({ show, link, siteId, onClose, owner_email }) => {
    const [message, set_message] = useState('');

    const email = useSelector((state) => state.user.email);
    const userName = useSelector((state) => state.user.userName);
    const feedback = useSelector((state) => state.feedback);
    const [fieldErrors, setFieldErrors] = useState({});
    const dispatch = useDispatch();

    const handleSubmit = async (event) => {
        const feedback = {
            siteId: link.siteId,
            dashboardId: link.dashboardId,
            linkDescription: link.description,
            owner_email,
            message,
            sender_email: email ? email : 'Anonymous',
            messageType: 'LinkFeedback',
        };

        if (!validate()) {
            return;
        }

        dispatch(sendLinkFeedback(feedback));
        TrackFeedback(siteId, link.dashboardId, link.linkId ,userName, email);
    };

    const validate = () => {
        let errors = {};

        if (!message) {
            errors['message'] = '';
        }

        setFieldErrors(errors);
        return Object.keys(errors).length === 0;
    };

    useEffect(() => {
        if (feedback.sendingLinkFeedbackSuccess && show) {
            onClose();
            set_message('');
            swal.fire({
                type: 'success',
                title: 'Thank you',
                text: 'Thank you for sending your feedback!',
                confirmButtonText: 'Ok',
            });
            dispatch(resetSendingLinkFeedback());
        }
    }, [feedback.sendingLinkFeedbackSuccess, show, onClose, dispatch]);

    return (
        <Modal allowClickOutsideToClose height='small' open={show} onCloseClicked={onClose}>
            <Grid container direction='column' className='link-feedback-modal'>
                <Grid container item justifyContent='center' className='link-feedback-modal__title'>
                    <Typography variant='h5'>Send us your feedback</Typography>
                </Grid>

                <Grid container direction='column' className='link-feedback-modal__body'>
                    {feedback.sendingLinkFeedback ? (
                        <AppLoader />
                    ) : (
                        <>
                            <Typography className='link-feedback-modal__description'>
                                Feedback for <em>{link.description}</em>
                            </Typography>

                            <TextField
                                error={'message' in fieldErrors}
                                helperText={'message' in fieldErrors && 'This field is required'}
                                className='link-feedback-modal__form-field'
                                variant='outlined'
                                label='Message *'
                                placeholder='Write a short message...'
                                value={message}
                                onChange={(e) => set_message(e.target.value)}
                                multiline
                                rows={4}
                            />
                        </>
                    )}
                </Grid>

                <Grid container justifyContent='space-between' className='link-feedback-modal__footer'>
                    <Button
                        className='link-feedback-modal__footer-button--cancel'
                        variant='contained'
                        color='default'
                        onClick={onClose}
                        disabled={feedback.sendingLinkFeedback}
                    >
                        Cancel
                    </Button>
                    <Button
                        className='link-feedback-modal__footer-button--save'
                        variant='contained'
                        color='primary'
                        disabled={feedback.sendingLinkFeedback}
                        onClick={(e) => {
                            handleSubmit(e);
                        }}
                        style={{ marginLeft: '10px' }}
                    >
                        Send
                    </Button>
                </Grid>
            </Grid>
        </Modal>
    );
};

export default LinkFeedbackModal;
